<a
  [routerLink]="appInternal ? appUrl : null"
  [attr.href]="appInternal ? null : appUrl"
  [attr.target]="appInternal ? null : '_blank'"
  [attr.rel]="appInternal ? null : 'noopener noreferrer'"
  (click)="onCardClick($event)"
  class="group relative h-full flex flex-col p-6 bg-white rounded-xl shadow-md transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg cursor-pointer no-underline select-none"
>
  <div class="flex items-center gap-4 mb-5">
    <div
      class="icon-badge relative w-14 h-14 rounded-xl bg-[--primary-200] text-white flex items-center justify-center flex-shrink-0 shadow-md transition-colors duration-300 group-hover:bg-[--primary-500]"
    >
      <div
        *ngIf="!loaded"
        class="absolute inset-0 flex items-center justify-center"
      >
        <p-skeleton shape="circle" size="2rem"></p-skeleton>
      </div>

      <img
        [src]="srcImg"
        (load)="onImageLoad()"
        (error)="handleImageError()"
        class="w-8 h-8 object-contain transition-opacity duration-300 group-hover:scale-110 p-1"
        [class.opacity-0]="!loaded"
        alt="Icon"
      />
    </div>

    <div class="flex-1 min-w-0 h-6 flex items-center">
      <h3
        *ngIf="loaded; else titleSkeleton"
        class="text-lg font-bold text-gray-700 m-0 leading-tight truncate w-full"
      >
        {{ appName }}
      </h3>
      <ng-template #titleSkeleton>
        <p-skeleton height="1.5rem" width="60%" borderRadius="4px"></p-skeleton>
      </ng-template>
    </div>
  </div>

  <div class="h-[2.85rem] mb-6 overflow-hidden">
    <p
      *ngIf="loaded; else textSkeleton"
      class="text-gray-500 text-sm leading-relaxed cursor-default line-clamp-2"
    >
      {{ appText }}
    </p>
    <ng-template #textSkeleton>
      <p-skeleton height="2.85rem" width="100%" borderRadius="4px"></p-skeleton>
    </ng-template>
  </div>

  <div
    class="card-footer mt-auto flex items-center pt-4 border-t border-gray-50"
  >
    <div class="flex-1 min-w-0 h-[1.25rem] flex items-center">
      <span
        *ngIf="loaded; else accessSkeleton"
        class="relative text-sm font-semibold transition-colors duration-300 card-link"
      >
        Access Module

        <span
          class="absolute left-0 -bottom-0.5 w-0 h-[2px] transition-all duration-300 group-hover:w-full card-link-line"
        ></span>
      </span>
      <ng-template #accessSkeleton>
        <p-skeleton height="1.25rem" width="40%" borderRadius="4px"></p-skeleton>
      </ng-template>
    </div>
  </div>
</a>
